import { FC } from 'react';

import { IllustrativeIconUserCheckmarkOffblackAnimated } from '@purpur/library/illustrative-icon/user-checkmark-offblack-animated';

export const AuthorImagePlaceholder: FC = () => {
    return <IllustrativeIconUserCheckmarkOffblackAnimated autoplay={false} />;
};
